// Single source of truth for backend URLs.
//
// `VITE_API_BASE_URL` is the build-time hostname of the Go api service
// (production: https://api.phos-ind.com). When unset, paths fall back to
// the legacy Vite dev-server proxy targets (`/api` → admin/Bun on :3000,
// `/events` → dashboard/Bun server on :3001).
//
// Routes ported from Bun → Go are under `/v1` on the new api.

const RAW = ((import.meta as any).env?.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

/** Base URL for every JSON CRUD endpoint. Append e.g. `/companies`. */
export const API_BASE: string = RAW ? `${RAW}/v1` : '/api';

/** SSE endpoint URL — full URL, no extra path concatenation. */
export const EVENTS_URL: string = RAW ? `${RAW}/v1/events` : '/events';
